// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Status labels (Label).
 */

.gh-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 2em;
  border: 1px solid transparent;
}

.gh-label-pending {
  color: var(--gh-fg-muted);
  border-color: var(--gh-border-default);
  background-color: var(--gh-canvas-subtle);
}

.gh-label-completed {
  color: #1a7f37;
  border-color: rgba(26, 127, 55, 0.3);
  background-color: #dafbe1;
}

.gh-label-failed {
  color: #cf222e;
  border-color: rgba(207, 34, 46, 0.3);
  background-color: #ffebe9;
}
`, "",{"version":3,"sources":["webpack://./src/styles/labels.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":["/*\n * Status labels (Label).\n */\n\n.gh-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n  border-radius: 2em;\n  border: 1px solid transparent;\n}\n\n.gh-label-pending {\n  color: var(--gh-fg-muted);\n  border-color: var(--gh-border-default);\n  background-color: var(--gh-canvas-subtle);\n}\n\n.gh-label-completed {\n  color: #1a7f37;\n  border-color: rgba(26, 127, 55, 0.3);\n  background-color: #dafbe1;\n}\n\n.gh-label-failed {\n  color: #cf222e;\n  border-color: rgba(207, 34, 46, 0.3);\n  background-color: #ffebe9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
